import * as z from "zod";

const schema = z.object({
	id: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const CreateCustomerResModel = {schema, model};
export type ICreateCustomerResModel = z.infer<typeof CreateCustomerResModel.model>;
export const DEFAULT_CREATE_CUSTOMER_RES: ICreateCustomerResModel = {
	id: ""
};
